function CollapseView({ stock, onUpsale, onEdit, onReceiveModal, onDelete }) {
  const DataCard = ({ icon, label, value, accent = "#83c14a" }) => (
    <div style={{
      background: "#fff",
      border: "1px solid #E5E7EB",
      borderRadius: "10px",
      padding: "16px",
      position: "relative",
      overflow: "hidden",
      transition: "all 0.2s ease"
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-2px)";
      e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "none";
    }}>
      <div style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "4px",
        height: "100%",
        background: accent
      }}></div>
      <div className="d-flex align-items-start gap-3">
        <div style={{
          width: "40px",
          height: "40px",
          borderRadius: "10px",
          background: `${accent}15`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0
        }}>
          <i className={icon} style={{ fontSize: "1.125rem", color: accent }}></i>
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: "0.75rem", color: "#6B7280", fontWeight: "600", marginBottom: "4px", textTransform: "uppercase", letterSpacing: "0.5px" }}>
            {label}
          </div>
          <div style={{ fontSize: "1rem", color: "#111827", fontWeight: "700", wordBreak: "break-word" }}>
            {value || "—"}
          </div>
        </div>
      </div>
    </div>
  );

  const formattedVoidDate = stock?.voidDate
    ? new Date(stock.voidDate).toLocaleString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      })
    : "—";

  return (
    <div style={{
      background: "#F9FAFB",
      border: "1px solid #E5E7EB",
      borderRadius: "12px",
      padding: "20px",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)"
    }}>
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        marginBottom: "20px",
        paddingBottom: "16px",
        borderBottom: "2px solid #E5E7EB"
      }}>
        <i className="bi bi-trash3-fill" style={{ fontSize: "1.25rem", color: "#83c14a" }}></i>
        <h6 style={{ margin: 0, fontSize: "1rem", fontWeight: "700", color: "#111827" }}>
          Waste Product Details
        </h6>
      </div>

      <div className="row g-3 mb-4">
        <div className="col-md-4">
          <DataCard 
            icon="bi bi-receipt"
            label="OR #"
            value={stock?.orNumber}
            accent="#83c14a"
          />
        </div>

        <div className="col-md-4">
          <DataCard 
            icon="bi bi-upc-scan"
            label="SKU"
            value={stock?.sku}
            accent="#3B82F6"
          />
        </div>

        <div className="col-md-4">
          <DataCard 
            icon="bi bi-bag-fill"
            label="Product Name"
            value={stock?.name}
            accent="#8B5CF6"
          />
        </div>

        <div className="col-md-4">
          <DataCard 
            icon="bi bi-currency-dollar"
            label="Amount"
            value={stock?.amount}
            accent="#10B981"
          />
        </div>

        <div className="col-md-4">
          <DataCard 
            icon="bi bi-calendar-x"
            label="Void Date"
            value={formattedVoidDate}
            accent="#EF4444"
          />
        </div>

        <div className="col-md-4">
          <DataCard 
            icon="bi bi-chat-left-text-fill"
            label="Description / Remarks"
            value={stock?.description}
            accent="#F59E0B"
          />
        </div>
      </div>

      {stock?.wasteType !== "Manual Waste" && (
        <div className="d-flex gap-3">
          <button 
            className="btn text-white" 
            onClick={onUpsale}
            style={{
              background: "linear-gradient(135deg, #83c14a 0%, #6fa83d 100%)",
              border: "none",
              padding: "10px 20px",
              fontWeight: "600",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(131, 193, 74, 0.3)",
              transition: "all 0.2s ease"
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 4px 12px rgba(131, 193, 74, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 2px 8px rgba(131, 193, 74, 0.3)";
            }}
          >
            <i className="bi bi-arrow-up-circle-fill me-2"></i> Upsale
          </button>

          {/* <button
            className="btn text-dark"
            style={{ backgroundColor: "#d1d1d1" }}
            onClick={onEdit}
          >
            <i className="bi bi-eye me-2"></i> View
          </button> */}
          {/* <button className="btn btn-danger" onClick={onDelete}>
          <i className="bi bi-trash-fill me-2"></i> Delete
        </button> */}
        </div>
      )}
    </div>
  );
}

export default CollapseView;
